export type WcsAlertDrawerPosition = 'bottom' | 'top' | "top-left" | "top-right" | "bottom-left" | "bottom-right";
